import { useTranslation } from 'react-i18next';
import Icon from './Icon';
import { getApplyParamters } from '../../js/utils/paramters';
import { useCookies } from 'react-cookie';
import useNavigationWithQuery from '../../hooks/useNavigationWithQuery';

export default function ApplyFloatingBtn() {
  const { t } = useTranslation(['HomePage']);
  const { queryParams } = useNavigationWithQuery();
  const [cookies] = useCookies();

  return (
    <a
      href={`https://manaraschool.heiapply.com/application/main_school?${getApplyParamters(
        cookies,
        queryParams
      )}`}
      target="_blank"
      className="button apply-now floating-btn"
      title="apply now"
      rel="noreferrer">
      <Icon name="open-light" />
      <span>{t('applyNow')}</span>
    </a>
  );
}
